"use client"

import { motion } from "framer-motion"

export default function CarCard({ src, title, subtitle, index, className = "", objectPosition = "center center" }) {
  return (
    <motion.div
      className={`relative overflow-hidden cursor-pointer group ${className}`}
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
    >
      {/* Black opacity overlay */}
      <div className="absolute inset-0 bg-black/40 z-[1] transition-all duration-500 group-hover:bg-black/65" />

      {/* Image */}
      <img
        src={src}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover
          transition-transform duration-700 ease-[cubic-bezier(0.25,0.1,0.25,1)]
          group-hover:scale-[1.06]"
        style={{ objectPosition }}
      />

      {/* Corner brackets */}
      <div className="absolute top-[10px] left-[10px] w-3 h-3 border-t-[1.5px] border-l-[1.5px] border-[#C9A24D] opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" />
      <div className="absolute top-[10px] right-[10px] w-3 h-3 border-t-[1.5px] border-r-[1.5px] border-[#C9A24D] opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" />
      <div className="absolute bottom-[10px] left-[10px] w-3 h-3 border-b-[1.5px] border-l-[1.5px] border-[#C9A24D] opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" />
      <div className="absolute bottom-[10px] right-[10px] w-3 h-3 border-b-[1.5px] border-r-[1.5px] border-[#C9A24D] opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" />

      {/* System index */}
      <div className="absolute top-3 left-3 z-10 font-mono text-[9px] text-[#C9A24D]
        tracking-[0.08em] opacity-0 group-hover:opacity-60
        transition-opacity duration-300 delay-100">
        {index}
      </div>

      {/* CENTER TITLE — visible on hover only */}
      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4
        opacity-0 group-hover:opacity-100 transition-opacity duration-500">

        {/* Gold line top */}
        <div className="w-0 group-hover:w-16 h-[1px] bg-[#C9A24D] mb-4
          transition-all duration-500 ease-[cubic-bezier(0.25,0.1,0.25,1)]" />

        {/* Title */}
        <h3 className="text-white text-2xl md:text-3xl font-semibold uppercase
          tracking-[0.2em] group-hover:tracking-[0.3em]
          transition-all duration-500">
          {title}
        </h3>

        {/* Subtitle */}
        {subtitle && (
          <p className="mt-2 font-mono text-[10px] text-[#C9A24D] tracking-[0.15em]
            translate-y-2 group-hover:translate-y-0
            transition-all duration-500 delay-100">
            {subtitle}
          </p>
        )}

        {/* Gold line bottom */}
        <div className="w-0 group-hover:w-16 h-[1px] bg-[#C9A24D] mt-4
          transition-all duration-500 ease-[cubic-bezier(0.25,0.1,0.25,1)]" />

      </div>

    </motion.div>
  )
}